import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  computed,
  input
} from '@angular/core';

/**
 * Atom: <osk-divider>
 * Horizontal or vertical visual separator with optional centered text label.
 */
@Component({
  selector: 'osk-divider',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrl: './osk-divider.component.scss',
  template: `
    <div [class]="dividerClasses()" role="separator" [attr.aria-orientation]="orientation()">
      @if (label() && orientation() === 'horizontal') {
        <span class="osk-divider__label">{{ label() }}</span>
      }
    </div>
  `
})
export class OSKDividerComponent {
  readonly orientation = input<'horizontal' | 'vertical'>('horizontal');
  readonly label = input<string | undefined>(undefined);

  protected readonly dividerClasses = computed<string>(() => {
    const classes: string[] = ['osk-divider', `osk-divider--${this.orientation()}`];
    if (this.label()) {
      classes.push('osk-divider--with-label');
    }
    return classes.join(' ');
  });
}
